import script from "./word.vue?vue&type=script&setup=true&lang=ts"
export * from "./word.vue?vue&type=script&setup=true&lang=ts"

import "./word.vue?vue&type=style&index=0&id=b9e13ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9e13ed8"]])

export default __exports__